// Need to use the React-specific entry point to import createApi
import { createApi } from '@reduxjs/toolkit/query/react';
import config from '../../config/config';
import axiosBaseQuery from './axiosBaseQuery/axiosBaseQuery';
import { ApiResponse, PlatformRecord } from './types/types';

// Define a service using a base URL and expected endpoints
export const platformsAPI = createApi({
  reducerPath: 'platformsAPI',
  baseQuery: axiosBaseQuery({
    baseUrl: config?.appUrl,
  }),
  keepUnusedDataFor: 900,
  endpoints: (builder) => ({
    getPlatforms: builder.query<PlatformRecord[], void>({
      query: () => ({
        url: `/auth/platform`,
        method: 'GET',
      }),
      transformResponse: (response: ApiResponse<PlatformRecord[]>) => response.body,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetPlatformsQuery } = platformsAPI;
